import { useSelector } from 'react-redux'
import { useLazyGetSessionQuery } from '@redux/queries/sessions'
import { useLazyRestrictedCheckQuery } from '@redux/queries/claimRecords'
import { connectorSessionIdSelector } from '@redux/slices/connectorSlice'
import { Logger } from '@utils/logger'
import { RestrictedCheckStatus } from '@typesApp/Session'

const PREFER_CACHE_VALUE = true

export type RestrictedCheckParams = {
  onSuccess?: (status: RestrictedCheckStatus) => void
  onError?: () => void
}

type UseRestrictedCheckReturn = (params?: RestrictedCheckParams) => void

export const useRestrictedCheck = (): UseRestrictedCheckReturn => {
  const sessionId = useSelector(connectorSessionIdSelector)
  const [fetchSession] = useLazyGetSessionQuery()
  const [restrictedCheck] = useLazyRestrictedCheckQuery()

  const performRestrictedCheck = (params?: RestrictedCheckParams) => {
    // ok to use cached value as session is invalidated when
    // commerce session Id changes
    fetchSession(sessionId, PREFER_CACHE_VALUE)
      .unwrap()
      .then(session => {
        doRestrictedCheck(session.customer?.id, params)
      })
      .catch(error => {
        Logger.error(error)
        params?.onError?.()
      })
  }

  const doRestrictedCheck = (customerNumber: string, params?: RestrictedCheckParams) => {
    restrictedCheck(customerNumber)
      .unwrap()
      .then(status => {
        params?.onSuccess?.(status)
      })
      .catch(error => {
        Logger.error(error)
        params?.onError?.()
      })
  }

  return performRestrictedCheck
}
